export const setQuestions = (questions: any) => ({
    type: 'SET_QUESTIONS',
    payload: questions,
  });
  